import * as React from "react"

export const GatsbyIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="8" fill="#F9F2FF" />
    <path
      d="M27.8574 20.0002H22.8574V21.4288H26.286C25.786 23.5716 24.2146 25.3574 22.1431 26.0716L13.9289 17.8574C14.786 15.3574 17.2146 13.5716 20.0003 13.5716C22.1431 13.5716 24.0717 14.6431 25.286 16.2859L26.3574 15.3574C24.9289 13.4288 22.6431 12.1431 20.0003 12.1431C16.286 12.1431 13.1431 14.7859 12.3574 18.2859L21.786 27.7145C25.2146 26.8574 27.8574 23.7145 27.8574 20.0002Z"
      fill="white"
    />
    <path
      d="M12.1426 20.0713C12.1426 22.0713 12.9283 23.9999 14.4283 25.4999C15.9283 26.9999 17.9283 27.7856 19.8569 27.7856L12.1426 20.0713Z"
      fill="white"
    />
    <path
      d="M20 10C14.5 10 10 14.5 10 20C10 25.5 14.5 30 20 30C25.5 30 30 25.5 30 20C30 14.5 25.5 10 20 10ZM14.4286 25.5714C12.9286 24.0714 12.1429 22.0714 12.1429 20.1429L19.9286 27.8571C17.9286 27.7857 15.9286 27.0714 14.4286 25.5714ZM21.7143 27.6429L12.3571 18.2857C13.1429 14.7857 16.2857 12.1429 20 12.1429C22.6429 12.1429 24.9286 13.4286 26.3571 15.3571L25.2857 16.2857C24.0714 14.6429 22.1429 13.5714 20 13.5714C17.2143 13.5714 14.8571 15.3571 13.9286 17.8571L22.1429 26.0714C24.2143 25.3571 25.7857 23.5714 26.2857 21.4286H22.8571V20H27.8571C27.8571 23.7143 25.2143 26.8571 21.7143 27.6429Z"
      fill="#7026B9"
    />
  </svg>
)
